const campania = process.env.VUE_APP_CAMP || "ofertaAutomotor";

const Google = {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.onload = function () {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-786692015";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.fbq;
  },
  init() {
    window.gtag("js", new Date());
    window.gtag("config", "AW-786692015");
  },
  paso1() {
    if (campania === "ofertaAutomotor") {
      window.gtag("event", "conversion", {
        send_to: "AW-786692015/jefGCLKOtaAYEK_vj_cC"
      });
    }
    if (campania === "ofertaHogar") {
      window.gtag("event", "conversion", {
        send_to: "AW-786692015/NJ4DCLSe3skYEK_vj_cC"
      });
    }
  },
  paso2() {
    if (campania === "ofertaAutomotor") {
      window.gtag("event", "conversion", {
        send_to: "AW-786692015/0ZrlCLWOtaAYEK_vj_cC"
      });
    }
    if (campania === "ofertaHogar") {
      window.gtag("event", "conversion", {
        send_to: "AW-786692015/Ud3PCLee3skYEK_vj_cC"
      });
    }
  },
  resumen() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/SvFVCLiOtaAYEK_vj_cC"
    });
  },
  condicion() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/BDgHCLuOtaAYEK_vj_cC"
    });
  },
  marca() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/h3QTCL6OtaAYEK_vj_cC"
    });
  },
  modelo() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/hznaCMGOtaAYEK_vj_cC"
    });
  },
  version() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/gGbSCMSOtaAYEK_vj_cC"
    });
  },
  gnc() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/kgtsCMeOtaAYEK_vj_cC"
    });
  },
  guardado() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/pouSCMqOtaAYEK_vj_cC"
    });
  },
  cotizacion_planes() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/kr5vCM2OtaAYEK_vj_cC"
    });
  },
  paso3() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/bnexCLqe3skYEK_vj_cC"
    });
  },
  paso4() {
    window.gtag("event", "conversion", {
      send_to: "AW-786692015/mzBsCL2e3skYEK_vj_cC"
    });
  }
};

export default Google;
